const AUDIT_ACTION_LABELS = {
  "auth.login_success": "Login Success",
  "auth.login_failed": "Login Failed",
  "auth.logout": "Logout",
  "auth.google_login_success": "Google Login Success",
  "auth.google_login_failed": "Google Login Failed",
  "auth.user_created": "User Created",
  "auth.user_create_failed": "User Create Failed",
  "auth.user_updated": "User Updated",
  "auth.user_activated": "User Activated",
  "auth.user_deactivated": "User Deactivated",
  "auth.role_assigned": "Role Assigned",
  "auth.role_removed": "Role Removed",
  "auth.role_changed": "Role Changed",
  "auth.permission_denied": "Permission Denied",
  "real_estate.source_enabled": "Source Enabled",
  "real_estate.source_disabled": "Source Disabled",
  "real_estate.source_updated": "Source Updated",
  "real_estate.source_run_started": "Source Run Started",
  "real_estate.listing_disabled": "Listing Disabled",
  "real_estate.listing_enabled": "Listing Enabled",
  "real_estate.listing_updated": "Listing Updated",
  "real_estate.duplicate_resolution_manual": "Manual Duplicate Resolution",
  "real_estate.duplicate_merged": "Duplicate Merged",
  "real_estate.duplicate_split": "Duplicate Split",
  "real_estate.duplicate_marked_not_duplicate": "Marked Not Duplicate",
};

export function formatAuditAction(action) {
  if (!action) {
    return "—";
  }

  if (AUDIT_ACTION_LABELS[action]) {
    return AUDIT_ACTION_LABELS[action];
  }

  return action
    .split(".")
    .map((segment) =>
      segment
        .split("_")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ")
    )
    .join(" · ");
}
